"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getViacomAccountDetailsGuard = void 0;
var tslib_1 = require("tslib");
var token_data_extractor_1 = require("../../../utils/token-data-extractor");
var user_data_response_validator_1 = require("../../../utils/user-data-response-validator");
var getViacomAccountDetailsGuard = function (requestRoute) { return function (response) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var tokenEmailAccountId, hasRequiredData, validationCallback;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, token_data_extractor_1.tokenDataExtractor.extractEmailAccountId()];
            case 1:
                tokenEmailAccountId = _a.sent();
                hasRequiredData = Boolean(tokenEmailAccountId) && Boolean(response === null || response === void 0 ? void 0 : response.id);
                if (!hasRequiredData) {
                    return [2 /*return*/, response];
                }
                validationCallback = function () { return tokenEmailAccountId === response.id; };
                return [2 /*return*/, user_data_response_validator_1.userDataResponseValidator.validateResponse({
                        response: response,
                        validationCallback: validationCallback,
                        reportingData: {
                            endpointUri: requestRoute,
                            message: "Viacom Account Details response is invalid for ".concat(tokenEmailAccountId, " compared with remote ").concat(response.id),
                            requestData: "accountId: ".concat(tokenEmailAccountId),
                            responseData: "accountId: ".concat(response.id),
                        },
                    })];
        }
    });
}); }; };
exports.getViacomAccountDetailsGuard = getViacomAccountDetailsGuard;
